require('./lbBeamer.scss');

const $inject = [];
const lbBeamerDir = function () {
  return {
    controller: 'lbBeamerCtrl',
    controllerAs: '$ctrl',
    bindToController: true,
    template: require('./lbBeamer.html'),
  };
};

lbBeamerDir.$inject = $inject;

export default lbBeamerDir;



// WEBPACK FOOTER //
// ./src/components/lbBeamer/lbBeamerDir.js